import {useState} from 'react';

import {DynamicStatusButton} from 'shells/button/dynamic-status-button/dynamic-status-button';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import {useGetSharedInboxConfig} from '../graphql/hooks/use-get-shared-inbox-config';

import {ForwardingStatusPopoverContent} from './forwarding-status-popover-content';
import {getLastVerifiedTime} from './helpers';

export function ForwardingStatusButton() {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const {sharedInboxConfig, isLoading} = useGetSharedInboxConfig();

    if (isLoading) {
        return <LoadingText height={31} width={184} />;
    }

    const sharedAddresses = sharedInboxConfig?.sharedAddresses ?? [];
    const hasVerifiedForwarding = sharedAddresses.some((address) =>
        Boolean(address.forwardingVerifiedTime)
    );

    return (
        <DynamicStatusButton
            text='Inbound forwarding'
            headerType={hasVerifiedForwarding ? 'success' : 'warning'}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            headerContent={
                <Body>
                    {hasVerifiedForwarding
                        ? 'Inbound forwarding verified'
                        : 'Inbound forwarding has not been verified yet'}
                </Body>
            }
            popoverContent={
                <ForwardingStatusPopoverContent
                    isVerified={hasVerifiedForwarding}
                    lastVerifiedTime={getLastVerifiedTime(sharedAddresses)}
                />
            }
        />
    );
}
